/* eslint-disable no-process-env */
import type { AuthProviderContext, AuthProviderProps, AuthProviderType } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import type { ReactNode, JSX } from 'react';

interface Props {
  authProvider: Provider<AuthProviderContext, AuthProviderProps>;
  children: ReactNode;
  useConditionalAuthProvider: boolean;
  authProviderType?: AuthProviderType;
}

export function ConditionalAuthProvider({
  authProvider: AuthProvider,
  useConditionalAuthProvider,
  children,
  authProviderType,
}: Props): JSX.Element {
  if (useConditionalAuthProvider) {
    return <AuthProvider>{children}</AuthProvider>;
  }

  return <AuthProvider providerType={authProviderType}>{children}</AuthProvider>;
}
